// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        // Optional
        loadProductFirst: true,
        numberFilterTree: 2
    },
};

var bcSfFilterTemplate = {
    'gridBorderClass': 'grid-item-border',
    'onSaleClass': 'on-sale',
    'soldOutClass': 'sold-out',

    'quickViewHtml': '<div class="quickview-button"><a href="javascript:void(0)" id="{{itemHandle}}" title="' + bcSfFilterConfig.label.quick_view + '">' + bcSfFilterConfig.label.quick_view + '</a></div>',
    'reviewHtml': '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>',

    // Grid Template
    'productGridItemHtml': '<div class="grid-item col-xs-6 ' + bcSfFilterConfig.custom.grid_item_width + ' {{itemGridBorderClass}} {{itemCropImageClass}}">' +
                                '<div class="inner product-item {{itemSoldOutClass}} {{itemSaleClass}} wow fadeIn" data-wow-delay="{{delayTime}}ms" id="product-{{itemId}}">' +
                                    '<div class="inner-top">' +
                                        '<div class="product-top">' +
                                            '<div class="product-image">' +
                                                '<a href="{{itemUrl}}" class="product-grid-image">' +
                                                    '<img src="{{itemThumbUrl}}" alt="{{itemTitle}}">' +
                                                    '<div class="hover"><img src="{{itemFlipImageUrl}}" alt="{{itemTitle}}" /></div>' +
                                                '</a>' +
                                            '</div>' +
                                            '{{itemLabels}}' +
                                            '<div class="product-des">' +
                                                '{{itemWishlist}}' +
                                                '<div class="action">{{itemAddToCart}}</div>' +
                                                '{{itemQuickView}}' +
                                            '</div>' +
                                        '</div>' +
                                        '<div class="product-bottom">' +
                                            '{{itemVendor}}' +
                                            '<a class="product-title" href="{{itemUrl}}">{{itemTitle}}</a>' +
                                            '{{itemReview}}' +
                                            '<div class="price-box">{{itemPrice}}</div>' +
                                            '<a href="{{itemUrl}}" style="text-decoration: none;"></a>' +
                                            '{{itemColorSwatches}}' +
                                        '</div>' +
                                    '</div>' +
                                '</div>' +
                            '</div>',

    // List Template
    'productListItemHtml':  '<div class="grid-item product-item {{itemSoldOutClass}} {{itemSaleClass}} wow fadeIn" data-wow-delay="{{delayTime}}ms" id="product-{{itemId}}">' +
                                '<div class="product-image">' +
                                    '<a href="{{itemUrl}}" class="product-list-thumb product-grid-image">' +
                                        '<img src="{{itemThumbUrl}}" alt="{{itemTitle}}">' +
                                    '</a>' +
                                    '{{itemLabels}}' +
                                '</div>' +

                                '<div class="product-details">' +
                                    '<a class="product-title" href="{{itemUrl}}">{{itemTitle}}</a>' +
                                    '{{itemVendor}}' +
                                    '{{itemReview}}' +
                                    '<div class="short-description">{{itemDescription}}</div>' +
                                    '{{itemColorSwatches}}' +
                                    '<div class="price-box">{{itemPrice}}</div>' +
                                    '<div class="action">{{itemAddToCart}}</div>' +
                                    '{{itemWishlist}}' +
                                '</div>' +
                            '</div>',

    // Pagination Template
    'previousActiveHtml': '<li class="text"><a href="{{itemUrl}}">Previous</a></li>',
    'previousDisabledHtml': '<li class="disabled"><span>Previous</span></li>',
    'nextActiveHtml': '<li class="text"><a href="{{itemUrl}}">Next</a></li>',
    'nextDisabledHtml': '<li class="disabled"><span>Next</span></li>',
    'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
    'pageItemSelectedHtml': '<li class="active"><span>{{itemTitle}}</span></li>',
    'pageItemRemainHtml': '<li><span>{{itemTitle}}</span></li>',
    'paginateHtml': '{{previous}}{{pageItems}}{{next}}',
};

BCSfFilter.prototype.buildProductGridItem = function(data, index, totalProduct) {
    /*** Prepare data ***/
    var images = data.images_info;
     // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;

    // Add class
    itemHtml = bcSfFilterConfig.custom.product_image_border ? itemHtml.replace(/{{itemGridBorderClass}}/g, bcSfFilterTemplate.gridBorderClass) : itemHtml.replace(/{{itemGridBorderClass}}/g, '');
    itemHtml = bcSfFilterConfig.custom.product_image_crop ? itemHtml.replace(/{{itemCropImageClass}}/g, 'crop_image') : itemHtml.replace(/{{itemCropImageClass}}/g, 'no_crop_image');
    itemHtml = soldOut ? itemHtml.replace(/{{itemSoldOutClass}}/g, bcSfFilterTemplate.soldOutClass) : itemHtml.replace(/{{itemSoldOutClass}}/g, '');
    itemHtml = onSale ? itemHtml.replace(/{{itemSaleClass}}/g, bcSfFilterTemplate.onSaleClass) : itemHtml.replace(/{{itemSaleClass}}/g, '');
    itemHtml = itemHtml.replace(/{{delayTime}}/g, bcSfFilterConfig.custom.time_lazy_load * index);

    // Add Thumbnail
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src'], '1024x1024') : bcSfFilterConfig.general.no_image_url;
    var itemFlipImageUrl = images.length > 1 ? this.optimizeImage(images[1]['src'], '1024x1024') : itemThumbUrl;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);
    itemHtml = itemHtml.replace(/{{itemFlipImageUrl}}/g, itemFlipImageUrl);

    // Add Label
    var itemLabelsHtml = '';
    if (onSale || soldOut) {
        itemLabelsHtml += '<div class="product-label">';
        if (onSale) {
            itemLabelsHtml += '<strong class="label">' + bcSfFilterConfig.label.sale + '</strong>';
        }
        if (soldOut) {
            itemLabelsHtml += '<strong class="sold-out-label">' + bcSfFilterConfig.label.sold_out + '</strong>';
        }
        itemLabelsHtml += '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);

    // Add Price
    var itemPriceHtml = '';
    if (onSale) {
        itemPriceHtml += '<p class="sale">';
        itemPriceHtml += '<span class="old-price"> ' + this.formatMoney(data.compare_at_price_min) +'</span>';
        itemPriceHtml += '<span class="special-price">';
        if (priceVaries) {
            itemPriceHtml += '<em>' + bcSfFilterConfig.label.from_price + ' </em>';
        }
        itemPriceHtml += this.formatMoney(data.price_min);
        itemPriceHtml += '</span>';
        itemPriceHtml += '</span></p>';
    } else {
        itemPriceHtml += '<p class="regular-product"><span>';
        if (priceVaries) {
            itemPriceHtml += '<em>' + bcSfFilterConfig.label.from_price + ' </em>'
        }
        itemPriceHtml += this.formatMoney(data.price_min, this.moneyFormat);
        itemPriceHtml += '</span></p>';
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add Vendor
    var itemVendorHtml = '';
    if (bcSfFilterConfig.custom.show_vendor) {
        itemVendorHtml = '<div class="product-vendor">' + data.vendor + '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add to cart
    var itemAddToCartHtml = '<form action="/cart/add" method="post" class="variants" id="product-actions-{{itemId}}" enctype="multipart/form-data" style="padding:0px;">';
    if (soldOut) {
        itemAddToCartHtml += '<input class="btn add-to-cart-btn" type="submit" value="' + bcSfFilterConfig.label.unavailable + '" disabled="disabled"/>';
    } else {
        if (data.variants.length > 1) {
            itemAddToCartHtml += '<input class="btn" type="button" onclick="window.location.href=\'{{itemUrl}}\'" value="' + bcSfFilterConfig.label.select_options + '" />';
        } else {
            itemAddToCartHtml += '<input type="hidden" name="id" value="' + firstVariant.id + '" />';
            itemAddToCartHtml += '<input class="btn add-to-cart-btn" type="submit" value="' + bcSfFilterConfig.label.add_to_cart + '" />';
        }
    }
    itemAddToCartHtml += '</form>';
    itemHtml = itemHtml.replace(/{{itemAddToCart}}/g, itemAddToCartHtml);

    // Add Quick view
    var itemQuickViewHtml = '';
    if (bcSfFilterConfig.custom.enable_quick_view) {
        itemQuickViewHtml = bcSfFilterTemplate.quickViewHtml;
    }
    itemHtml = itemHtml.replace(/{{itemQuickView}}/g, itemQuickViewHtml);

    // Add Review
    var itemReviewHtml = bcSfFilterConfig.custom.display_product_reviews ? bcSfFilterTemplate.reviewHtml : '';
    itemHtml = itemHtml.replace(/{{itemReview}}/g, itemReviewHtml);

    // Add Color Swatches
    itemHtml = itemHtml.replace(/{{itemColorSwatches}}/g, buildColorSwatches(data));

    // Add Wishlist
    itemHtml = itemHtml.replace(/{{itemWishlist}}/g, buildWishlist(data));

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    return itemHtml;
}

BCSfFilter.prototype.buildProductListItem = function(data, index, totalProduct) {
    /*** Prepare data ***/
    var images = data.images_info;
     // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

    // Get Template
    var itemHtml = bcSfFilterTemplate.productListItemHtml;

    // Add class
    itemHtml = soldOut ? itemHtml.replace(/{{itemSoldOutClass}}/g, bcSfFilterTemplate.soldOutClass) : itemHtml.replace(/{{itemSoldOutClass}}/g, '');
    itemHtml = onSale ? itemHtml.replace(/{{itemSaleClass}}/g, bcSfFilterTemplate.onSaleClass) : itemHtml.replace(/{{itemSaleClass}}/g, '');
    itemHtml = itemHtml.replace(/{{delayTime}}/g, bcSfFilterConfig.custom.time_lazy_load * index);

    // Add Thumbnail
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src']) : bcSfFilterConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

    // Add Label
    var itemLabelsHtml = '';
    if (onSale || soldOut) {
        itemLabelsHtml += '<div class="product-label">';
        if (onSale) {
            itemLabelsHtml += '<strong class="label">' + bcSfFilterConfig.label.sale + '</strong>';
        }
        if (soldOut) {
            itemLabelsHtml += '<strong class="sold-out-label">' + bcSfFilterConfig.label.sold_out + '</strong>';
        }
        itemLabelsHtml += '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);

    // Add Price
    var itemPriceHtml = '';
    if (onSale) {
        itemPriceHtml += '<p class="sale">';
        itemPriceHtml += '<span class="old-price money"> ' + this.formatMoney(data.compare_at_price_min) +'</span>';
        if (priceVaries) {
            itemPriceHtml += '<span class="special-price"><em>' + bcSfFilterConfig.label.from_price + ' </em>';
        } else {
            itemPriceHtml += '<span class="special-price">';
        }
        itemPriceHtml += this.formatMoney(data.price_min, this.moneyFormat);
        itemPriceHtml += '</span></p>';
    } else {
        itemPriceHtml += '<p class="regular-product">';
        if (priceVaries) {
            itemPriceHtml += '<span class="money"><em>' + bcSfFilterConfig.label.from_price + ' </em>' + this.formatMoney(data.price_min) + '</span>';
        } else {
            itemPriceHtml += '<span class="money">' + this.formatMoney(data.price_min) + '</span>';
        }
        itemPriceHtml += '</p>';
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add Vendor
    var itemVendorHtml = '';
    if (bcSfFilterConfig.custom.show_vendor) {
        itemVendorHtml = '<div class="product-vendor">' + data.vendor + '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add to cart
    var itemAddToCartHtml = '<form action="/cart/add" method="post" class="variants" id="product-actions-{{itemId}}" enctype="multipart/form-data" style="padding:0px;">';
    if (soldOut) {
        itemAddToCartHtml += '<input class="btn add-to-cart-btn" type="submit" value="' + bcSfFilterConfig.label.unavailable + '" disabled="disabled"/>';
    } else {
        if (data.variants.length > 1) {
            itemAddToCartHtml += '<input class="btn" type="button" onclick="window.location.href=\'{{itemUrl}}\'" value="' + bcSfFilterConfig.label.select_options + '" />';
        } else {
            itemAddToCartHtml += '<input type="hidden" name="id" value="' + firstVariant.id + '" />';
            itemAddToCartHtml += '<input class="btn add-to-cart-btn" type="submit" value="' + bcSfFilterConfig.label.add_to_cart + '" />';
        }
    }
    itemAddToCartHtml += '</form>';
    itemHtml = itemHtml.replace(/{{itemAddToCart}}/g, itemAddToCartHtml);

    // Add Quick view
    var itemQuickViewHtml = '';
    if (bcSfFilterConfig.custom.enable_quick_view) {
        itemQuickViewHtml = bcSfFilterTemplate.quickViewHtml;
    }
    itemHtml = itemHtml.replace(/{{itemQuickView}}/g, itemQuickViewHtml);

    // Add Review
    var itemReviewHtml = bcSfFilterConfig.custom.display_product_reviews ? bcSfFilterTemplate.reviewHtml : '';
    itemHtml = itemHtml.replace(/{{itemReview}}/g, itemReviewHtml);

    // Add Color Swatches
    itemHtml = itemHtml.replace(/{{itemColorSwatches}}/g, buildColorSwatches(data));

    // Add Wishlist
    itemHtml = itemHtml.replace(/{{itemWishlist}}/g, buildWishlist(data));

    // Add Description
    var itemDescription = '';
    if (data.body_html.indexOf('[countdown]') !== -1) {
        itemDescription = jQ('<p>' + data.body_html + '</p>').text();
        var tempArr = itemDescription.split('[/countdown]');
        itemDescription = tempArr.pop();
        itemDescription = this.truncateByWord(itemDescription, 50);
    }
    itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    return itemHtml;
}

// Build Wishlist
function buildWishlist(data) {
    // Add Wishlist
    var wishlistHtml = '';
    if (bcSfFilterConfig.custom.enable_wishlist) {
        if (bcSfFilterConfig.customer.email != '') {
            var value = (data.id).toString();
            var productId = (data.id).toString();
            for (var k in bcSfFilterConfig.customer.tags) {
                var tagID = bcSfFilterConfig['customer']['tags'][k];
                if (tagID.indexOf(productId) > -1) {
                    value = 'x' + tagID;
                }
                if (value.length == 0) value = productId;
            }
            if (value.length > 0) {
                var check = ((value.length - productId.length) / 2).toString();
                check = check.split('.');
                var display = check.length > 1 && check[1].indexOf('5') > - 1 ? false : true;
            }
            if (typeof display !== 'undefined' && display == true) {
                wishlistHtml += '<form method="post" action="/contact#contact_form" id="contact_form" class="contact-form" accept-charset="UTF-8">';
                wishlistHtml += '<input type="hidden" value="customer" name="form_type">';
                wishlistHtml += '<input type="hidden" name="utf8" value="✓">';
                wishlistHtml += '<input type="hidden" name="contact[email]" value="' + bcSfFilterConfig.customer.email + '"/>';
                wishlistHtml += '<input type="hidden" name="contact[tags]" value="' + value + '" />';
                wishlistHtml += '<button class="wishlist">' + bcSfFilterConfig.label.add_to_wishlist + '</button>';
                wishlistHtml += '</form>';
            } else {
                wishlistHtml += '<a class="wishlist" href="/pages/wish-list" title="' + bcSfFilterConfig.label. wishlist_note + '">' +
                                    '<span class="icon"></span>' +
                                    '<span class="wishlist_text">' + bcSfFilterConfig.label.added_to_wishlist + '</span>' +
                                '</a>';
            }
        } else {
            wishlistHtml = '<a class="wishlist" href="/account/login" title="' + bcSfFilterConfig.label.add_to_wishlist + '">' +
                                    '<span class="icon"></span>' +
                                    '<span class="wishlist_text">' + bcSfFilterConfig.label.add_to_wishlist + '</span>' +
                                '</a>';
        }
    }
    return wishlistHtml;
}

// Build Color Swatches
function buildColorSwatches(data) {
    var colorSwatchesHtml = '';
    if (bcSfFilterConfig.custom.display_item_swatch) {
        colorSwatchesHtml += '<ul class="item-swatch">';
        for (var index in data.options) {
            var option = data['options'][index].toLowerCase();
            if (option == 'color') {
                var colorlist = '';
                var color = '';
                for (var k in data.variants) {
                    var variant = data['variants'][k];
                    color = variant['options'][index];
                    if (colorlist.indexOf(color) == -1) {
                        var text = bcsffilter.slugify(color);
                        var border = text == 'white' ? 'border: 1px solid #cbcbcb;' : '';
                        colorSwatchesHtml += '<li>';
                        colorSwatchesHtml += '<label style="' + border + ' background-color: ' + bcsffilter.slugify(color.split(' ').pop()) + '; background-image: url(' + bcSfFilterConfig.general.asset_url.replace('bc-sf-filter.js', text + '.png') + ');"></label>';
                        if (variant.image !== null) {
                            colorSwatchesHtml += '<div class="hidden">' +
                                                    '<a href="' + bcsffilter.optimizeImage(variant.image) + '"></a>' +
                                                  '</div>';
                        }
                        colorSwatchesHtml += '</li>';
                        var templist = colorlist + color + ' ';
                        colorlist = templist;
                    }
                }
            }
        }
        colorSwatchesHtml += '</ul>';
    }
    return colorSwatchesHtml;
}

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    // Get page info
    var currentPage = parseInt(this.queryParams.page);
    var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

    // If it has only one page, clear Pagination
    if (totalPage == 1) {
        jQ(this.selector.pagination).html('');
        return false;
    }

    if (this.getSettingValue('general.paginationType') == 'default') {
        var paginationHtml = bcSfFilterTemplate.paginateHtml;

        // Build Previous
        var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
        previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
        paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

        // Build Next
        var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml :  bcSfFilterTemplate.nextDisabledHtml;
        nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
        paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

        // Create page items array
        var beforeCurrentPageArr = [];
        for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
            beforeCurrentPageArr.unshift(iBefore);
        }
        if (currentPage - 4 > 0) {
            beforeCurrentPageArr.unshift('...');
        }
        if (currentPage - 4 >= 0) {
            beforeCurrentPageArr.unshift(1);
        }
        beforeCurrentPageArr.push(currentPage);

        var afterCurrentPageArr = [];
        for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
            afterCurrentPageArr.push(iAfter);
        }
        if (currentPage + 3 < totalPage) {
            afterCurrentPageArr.push('...');
        }
        if (currentPage + 3 <= totalPage) {
            afterCurrentPageArr.push(totalPage);
        }

        // Build page items
        var pageItemsHtml = '';
        var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
        for (var iPage = 0; iPage < pageArr.length; iPage++) {
            if (pageArr[iPage] == '...') {
                pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
            } else {
                pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
            }
            pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
            pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
        }
        paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

        jQ(this.selector.pagination).html(paginationHtml);
    }
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
    var _this = this;
    jQ('.dropdown-menu li').removeClass('active');
    jQ('.dropdown-menu li').each(function() {
        if (jQ(this).children().attr('href') == _this.queryParams.sort) {
            jQ(this).addClass('active');
            jQ('.filter-sortby button span').text(jQ(this).children().text());
        }
    });
};
BCSfFilter.prototype.buildSortingEvent = function() {
    var _this = this;
    jQ('.dropdown-menu ' + ' li a').click(function(e) {
        onInteractWithToolbar(e, 'sort', _this.queryParams.sort, jQ(this).attr('href'));
    })
};

// Build Display type
BCSfFilter.prototype.buildFilterDisplayType = function() {
    var itemHtml = '<label>' + bcSfFilterConfig.label.view_as + '</label>';
    itemHtml += '<a href="' + this.buildToolbarLink('display', 'list', 'grid') + '" title="' + bcSfFilterConfig.label.grid_view + '" class="grid bc-sf-filter-display-grid"><span>' + bcSfFilterConfig.label.grid_view  + '</span></a> ';
    itemHtml += '<a href="' + this.buildToolbarLink('display', 'grid', 'list') + '" title="' + bcSfFilterConfig.label.list_view  + '" class="list bc-sf-filter-display-list"><span>' + bcSfFilterConfig.label.list_view  + '</span></a>';
    jQ(this.selector.topDisplayType).html(itemHtml);

    // Active current display type
    jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').removeClass('active');
    jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').removeClass('active');
    if (this.queryParams.display == 'list') {
        jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').addClass('active');
    } else if (this.queryParams.display == 'grid') {
        jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').addClass('active');
    }
};

BCSfFilter.prototype.buildExtrasProductList = function(data) {
    $('#bc-sf-filter-products').removeClass();
    if (this.queryParams.display == 'list') {
        $('#bc-sf-filter-products').addClass('product-list');
    } else {
        $('#bc-sf-filter-products').addClass('product-collection products-grid row');
    }
};

// Build Additional Elements
BCSfFilter.prototype.buildAdditionalElements = function(data) {
    // Call Theme functions
    bcElla.initQuickView();
    bcElla.initAddToCart();
    bcElla.initProductWishlist();
    bcElla.initRemoveWishlist();
    if(jQ('.sidebar').length > 0){
      jQ('body').addClass('bc-has-sidebar');
    }
};


    // Build Default layout
function buildDefaultLink(a,b){var c=window.location.href.split("?")[0];return c+="?"+a+"="+b}BCSfFilter.prototype.buildDefaultElements=function(a){if(bcSfFilterConfig.general.hasOwnProperty("collection_count")&&jQ("#bc-sf-filter-bottom-pagination").length>0){var b=bcSfFilterConfig.general.collection_count,c=parseInt(this.queryParams.page),d=Math.ceil(b/this.queryParams.limit);if(1==d)return jQ(this.selector.pagination).html(""),!1;if("default"==this.getSettingValue("general.paginationType")){var e=bcSfFilterTemplate.paginateHtml,f="";f=c>1?bcSfFilterTemplate.hasOwnProperty("previousActiveHtml")?bcSfFilterTemplate.previousActiveHtml:bcSfFilterTemplate.previousHtml:bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml")?bcSfFilterTemplate.previousDisabledHtml:"",f=f.replace(/{{itemUrl}}/g,buildDefaultLink("page",c-1)),e=e.replace(/{{previous}}/g,f);var g="";g=c<d?bcSfFilterTemplate.hasOwnProperty("nextActiveHtml")?bcSfFilterTemplate.nextActiveHtml:bcSfFilterTemplate.nextHtml:bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml")?bcSfFilterTemplate.nextDisabledHtml:"",g=g.replace(/{{itemUrl}}/g,buildDefaultLink("page",c+1)),e=e.replace(/{{next}}/g,g);for(var h=[],i=c-1;i>c-3&&i>0;i--)h.unshift(i);c-4>0&&h.unshift("..."),c-4>=0&&h.unshift(1),h.push(c);for(var j=[],k=c+1;k<c+3&&k<=d;k++)j.push(k);c+3<d&&j.push("..."),c+3<=d&&j.push(d);for(var l="",m=h.concat(j),n=0;n<m.length;n++)"..."==m[n]?l+=bcSfFilterTemplate.pageItemRemainHtml:l+=m[n]==c?bcSfFilterTemplate.pageItemSelectedHtml:bcSfFilterTemplate.pageItemHtml,l=l.replace(/{{itemTitle}}/g,m[n]),l=l.replace(/{{itemUrl}}/g,buildDefaultLink("page",m[n]));e=e.replace(/{{pageItems}}/g,l),jQ(this.selector.pagination).html(e)}}if(bcSfFilterTemplate.hasOwnProperty("sortingHtml")&&jQ(this.selector.topSorting).length>0){jQ(this.selector.topSorting).html("");var o=this.getSortingList();if(o){var p="";for(var q in o)p+='<option value="'+q+'">'+o[q]+"</option>";var r=bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g,p);jQ(this.selector.topSorting).html(r);var s=void 0!==this.queryParams.sort_by?this.queryParams.sort_by:this.defaultSorting;jQ(this.selector.topSorting+" select").val(s),jQ(this.selector.topSorting+" select").change(function(a){window.location.href=buildDefaultLink("sort_by",jQ(this).val())})}}};

    // Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData=function(data){for(var k=0;k<data.length;k++){data[k]['images']=data[k]['images_info'];if(data[k]['images'].length>0){data[k]['featured_image']=data[k]['images'][0]}else{data[k]['featured_image']={src:bcSfFilterConfig.general.no_image_url,width:'',height:'',aspect_ratio:0}}data[k]['url']='/products/'+data[k].handle;var optionsArr=[];for(var i=0;i<data[k]['options_with_values'].length;i++){optionsArr.push(data[k]['options_with_values'][i]['name'])}data[k]['options']=optionsArr;data[k]['price_min']*=100,data[k]['price_max']*=100,data[k]['compare_at_price_min']*=100,data[k]['compare_at_price_max']*=100;data[k]['price']=data[k]['price_min'];data[k]['compare_at_price']=data[k]['compare_at_price_min'];data[k]['price_varies']=data[k]['price_min']!=data[k]['price_max'];var firstVariant=data[k]['variants'][0];if(getParam('variant')!==null&&getParam('variant')!=''){var paramVariant=data.variants.filter(function(e){return e.id==getParam('variant')});if(typeof paramVariant[0]!=='undefined')firstVariant=paramVariant[0]}else{for(var i=0;i<data[k]['variants'].length;i++){if(data[k]['variants'][i].available){firstVariant=data[k]['variants'][i];break}}}data[k]['selected_or_first_available_variant']=firstVariant;for(var i=0;i<data[k]['variants'].length;i++){var variantOptionArr=[];var count=1;var variant=data[k]['variants'][i];var variantOptions=variant['merged_options'];if(Array.isArray(variantOptions)){for(var j=0;j<variantOptions.length;j++){var temp=variantOptions[j].split(':');data[k]['variants'][i]['option'+(parseInt(j)+1)]=temp[1];data[k]['variants'][i]['option_'+temp[0]]=temp[1];variantOptionArr.push(temp[1])}data[k]['variants'][i]['options']=variantOptionArr}data[k]['variants'][i]['compare_at_price']=parseFloat(data[k]['variants'][i]['compare_at_price'])*100;data[k]['variants'][i]['price']=parseFloat(data[k]['variants'][i]['price'])*100}data[k]['description']=data[k]['content']=data[k]['body_html']}return data};

/* Start Fix version 2.3.2 */
BCSfFilter.prototype.addFilterTreeItem=function(e,r,t,i){e=jQ.parseHTML(e),i=void 0!==i?i:this.getSelector("filterTree");void 0!==r&&"before"==r?jQ(i+t).prepend(e):jQ(i+t).append(e)};
/* End Fix version 2.3.2 */

// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
    var self = bcsffilter;
    var ext = typeof ext !== 'undefined' ? ext : 'png';
    var version = typeof version !== 'undefined' ? version : '1';
    var prIndex = self.fileUrl.lastIndexOf('?');
    if (prIndex > 0) {
        var filePath = self.fileUrl.substring(0, prIndex);
    } else {
        var filePath = self.fileUrl;
    }
    filePath += fileName + '.' + ext + '?v=' + version;
    return filePath;
}

BCSfFilter.prototype.getFilterData=function(eventType,errorCount){function BCSend(eventType,errorCount){var self=bcsffilter;var errorCount=typeof errorCount!=="undefined"?errorCount:0;self.showLoading();if(typeof self.buildPlaceholderProductList=="function"){self.buildPlaceholderProductList(eventType)}self.beforeGetFilterData(eventType);self.prepareRequestParams(eventType);self.queryParams["callback"]="BCSfFilterCallback";self.queryParams["event_type"]=eventType;var url=self.isSearchPage()?self.getApiUrl("search"):self.getApiUrl("filter");var script=document.createElement("script");script.type="text/javascript";var timestamp=(new Date).getTime();script.src=url+"?t="+timestamp+"&"+jQ.param(self.queryParams);script.id="bc-sf-filter-script";script.async=true;var resendAPITimer,resendAPIDuration;resendAPIDuration=2e3;script.addEventListener("error",function(e){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}if(errorCount<3){errorCount++;if(resendAPITimer){clearTimeout(resendAPITimer)}resendAPITimer=setTimeout(self.getFilterData("resend",errorCount),resendAPIDuration)}else{self.buildDefaultElements(eventType)}});document.getElementsByTagName("head")[0].appendChild(script);script.onload=function(){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}}}this.requestFilter(BCSend,eventType,errorCount)};BCSfFilter.prototype.requestFilter=function(sendFunc,eventType,errorCount){sendFunc(eventType,errorCount)};


/* start-boost-2.4.8 */
BCSfFilter.prototype.buildFilterOptionItem=function(html,iLabel,iValue,fOType,fOId,fOLabel,fODisplayType,fOSelectType,fOItemValue,fOData){var keepValuesStatic=fOData.hasOwnProperty("keepValuesStatic")?fOData.keepValuesStatic:false;if(fOType=="review_ratings"&&this.getSettingValue("general.ratingSelectionStyle")=="text"){var title=this.getReviewRatingsLabel(fOItemValue.from)}else{var title=this.customizeFilterOptionLabel(iLabel,fOData.prefix,fOType)}if(keepValuesStatic===true)var productNumber=null;else var productNumber=fOItemValue.hasOwnProperty("doc_count")?fOItemValue.doc_count:0;html=html.replace(/{{itemLabel}}/g,this.buildFilterOptionLabel(iLabel,productNumber,fOData));html=html.replace(/{{itemLink}}/g,this.buildFilterOptionLink(fOId,iValue,fOType,fODisplayType,fOSelectType,keepValuesStatic));html=html.replace(/{{itemValue}}/g,encodeURIParamValue(iValue));html=html.replace(/{{itemTitle}}/g,title);html=html.replace(/{{itemFunc}}/g,"onInteractWithFilterOptionValue(event, this, '"+fOType+"', '"+fODisplayType+"', '"+fOSelectType+"', '"+keepValuesStatic+"')");html=this.checkFilterOptionSelected(fOId,iValue,fOType,fODisplayType)?html.replace(/{{itemSelected}}/g,"selected"):html.replace(/{{itemSelected}}/g,"");var htmlElement=jQ(html);htmlElement.children().attr({"data-id":fOId,"data-value":encodeURIParamValue(iValue),"data-parent-label":fOLabel,"data-title":title,"data-count":productNumber});if(fOType!="collection"){htmlElement.children().attr("rel","nofollow")}if(fOType=="collection")htmlElement.children().attr("data-collection-scope",fOItemValue.key);return jQ(htmlElement)[0].outerHTML};
/* end-boost-2.4.8 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
